"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactHookForm = require("react-hook-form");
var _InputFeedback = _interopRequireDefault(require("../hocs/InputFeedback"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _useOutsideClick = _interopRequireDefault(require("../../hooks/useOutsideClick"));
var _Form = _interopRequireDefault(require("../hocs/Form"));
var _utils = require("../../utils");
var _UIElementSizesEnum = require("../ts/enums/UIElementSizesEnum");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
const _excluded = ["name", "placeholder", "options", "disabled", "defaultValue", "doNotShowFeedback", "onChangeInput"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const defaultProps = {
  size: _UIElementSizesEnum.UIElementSizesEnum.Medium,
  withBorder: true,
  width: '100%',
  defaultValue: undefined,
  onChangeInput() {}
};
function SelectComponent(props) {
  const _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    {
      name,
      placeholder,
      options,
      disabled,
      defaultValue,
      doNotShowFeedback,
      onChangeInput
    } = _defaultProps$props,
    restOfProps = _objectWithoutProperties(_defaultProps$props, _excluded);
  const [selectedOption, setSelectedOption] = (0, _react.useState)({
    value: '',
    label: ''
  });
  const [showOptions, setShowOptions] = (0, _react.useState)(false);
  const {
    register,
    control,
    formState: {
      errors
    }
  } = _Form.default.useForm();
  const ref = (0, _react.useRef)(null);
  const fieldError = (0, _utils.getObjectField)(errors, name);
  const handleShowOptions = (0, _react.useCallback)(() => {
    if (disabled) return;
    setShowOptions(!showOptions);
  }, [disabled, showOptions]);
  const handleSetOption = _ref => {
    let {
      label,
      value
    } = _ref;
    const newOption = {
      label: String(label || ''),
      value: String(value || '')
    };
    handleShowOptions();
    setSelectedOption(newOption);
    onChangeInput === null || onChangeInput === void 0 || onChangeInput(newOption);
  };
  (0, _useOutsideClick.default)(ref, handleShowOptions, showOptions);
  (0, _react.useEffect)(() => {
    if (Boolean(defaultValue)) {
      setSelectedOption(options === null || options === void 0 ? void 0 : options.find(_ref2 => {
        let {
          value
        } = _ref2;
        return String(value) === String(defaultValue);
      }));
    }
  }, [defaultValue, options]);
  const {
    label,
    value
  } = selectedOption || {};
  const Container = (0, _react.useMemo)(() => doNotShowFeedback ? Wrapper : _InputFeedback.default, [doNotShowFeedback]);
  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: name,
    control: control,
    render: _ref3 => {
      let {
        field: {
          onChange
        }
      } = _ref3;
      return /*#__PURE__*/_react.default.createElement(Container, _extends({}, restOfProps, {
        errors: fieldError,
        hasError: Boolean(fieldError === null || fieldError === void 0 ? void 0 : fieldError.message),
        name: name
      }), /*#__PURE__*/_react.default.createElement(Wrapper, {
        ref: ref
      }, /*#__PURE__*/_react.default.createElement(HiddenInput, _extends({
        readOnly: true,
        value: value,
        name: name,
        id: name
      }, register(name))), /*#__PURE__*/_react.default.createElement(SelectedValueRendering, _extends({}, restOfProps, {
        disabled: disabled,
        hasError: Boolean(fieldError === null || fieldError === void 0 ? void 0 : fieldError.message),
        onClick: handleShowOptions
      }), /*#__PURE__*/_react.default.createElement("p", null, (0, _utils.capitalize)(label || placeholder)), /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "expand_".concat(showOptions ? 'less' : 'more'),
        size: 22,
        color: "black"
      })), showOptions && /*#__PURE__*/_react.default.createElement(OptionsContainer, null, options === null || options === void 0 ? void 0 : options.map(option => /*#__PURE__*/_react.default.createElement(OptionItem, {
        key: option === null || option === void 0 ? void 0 : option.value,
        onClick: () => {
          onChange(String(option === null || option === void 0 ? void 0 : option.value));
          handleSetOption(option);
        }
      }, (0, _utils.capitalize)(option === null || option === void 0 ? void 0 : option.label))))));
    },
    defaultValue: defaultValue
  });
}
const Wrapper = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  p,\n  li {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    font-size: 14px;\n  }\n"])));
const HiddenInput = _styled.default.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: none;\n"])));
const SelectedValueRendering = _styled.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 10px;\n  padding: 0 12px;\n  cursor: pointer;\n\n  background-color: ", ";\n  color: ", ";\n\n  border: 1px solid\n    ", ";\n\n  ", "\n\n  width: ", ";\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    display: none;\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  ", "\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.NEUTRAL.CARD;
}, _ref5 => {
  let {
    readOnly,
    disabled,
    theme
  } = _ref5;
  return (0, _utils.hexToRGBA)(theme === null || theme === void 0 ? void 0 : theme.colors.FONT.TITLE, readOnly || disabled ? 0.65 : 1);
}, _ref6 => {
  let {
    theme,
    withBorder
  } = _ref6;
  return withBorder ? theme.colors.NEUTRAL.SELECTED : theme.colors.NEUTRAL.TRANSPARENT;
}, _ref7 => {
  let {
    theme,
    hasError
  } = _ref7;
  return hasError && "border: 1px solid ".concat(theme.colors.MAIN.ERROR, ";");
}, _ref8 => {
  let {
    width
  } = _ref8;
  return width;
}, _ref9 => {
  let {
    size
  } = _ref9;
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Small) return 'height: 40px;';
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Medium) return 'height: 45px;';
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Large) return 'height: 50px;';
});
const OptionsContainer = _styled.default.ul(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border-radius: 5px;\n  background: ", ";\n  border: 1px solid\n    ", ";\n  max-height: 200px;\n  margin-top: 5px !important;\n  position: absolute;\n  left: 0;\n  right: 0;\n  overflow: auto;\n  z-index: 3;\n  box-shadow: 0 0px 8px -5px rgba(0, 0, 0, 0.3);\n"])), _ref0 => {
  let {
    theme
  } = _ref0;
  return theme.colors.NEUTRAL.CARD;
}, _ref1 => {
  let {
    theme
  } = _ref1;
  return (0, _utils.hexToRGBA)(theme.colors.NEUTRAL.SELECTED, 0.5);
});
const OptionItem = _styled.default.li(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  padding: 10px 15px;\n\n  &:hover {\n    border-radius: 5px;\n    background-color: ", ";\n  }\n"])), _ref10 => {
  let {
    theme
  } = _ref10;
  return (0, _utils.hexToRGBA)(theme.colors.MAIN.PRIMARY, 0.04);
});
var _default = exports.default = SelectComponent;